import { Button, InlineLoading, TextInput } from "@carbon/react";
import { useDispatch, useSelector } from 'react-redux'
import { tokenRequestThunk } from "../../features/user/userThunks"
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom"
import { pushNotification } from "../../features/application/applicationSlice";
import { selectUser, selectAuthLoading, selectUserError } from "../../features/user/userSlice";
import { NotificationModel } from "../../models/Notification";
import { checkToken } from "../../apiClient/apiClient";
import { ArrowRight } from "@carbon/icons-react";
import { 
    checkError, 
    doLoginKey, 
    getErrorState,
    validateLogin,
    handleLoginInputs
} from './utils';


const Index = () => {
    const dispatch = useDispatch();

    const user = useSelector(selectUser)
    const authLoading = useSelector(selectAuthLoading)
    const userError = useSelector(selectUserError)
    
    const navigate = useNavigate()
    const location = useLocation()
    const inputRef = useRef()

    const [invalid_dictionary, setinvalidDictionary] = useState({
        'invalid_username': false,
        'invalid_password': false,
        invalidText_username: '',
        invalidText_password: '',
        disabled: true
    });
    const [loginForm, setData] = useState({ username: "", password: "" })
    
    useEffect(() => {
        if (location.pathname === '/login' && checkToken(user.token_refresh)) {
            navigate("/dashboard")
        }
    }, [location.pathname, user.token_refresh, navigate])
    
    return (
        <div className="page-container login-screen">
            <div className="background-image-container"></div>
            <div className="login-panel">
                <div className="generic-element-panel login-container">
                    <div className="generic-form">
                        <div className="generic-form__header">
                            <h1>Acceso</h1>
                            <p>
                            ¿No tienes una cuenta? Contacte{" "}
                            <a href="mailto:soporte@colmenadata.com" className="pointer">
                                con nosotros
                            </a>
                            </p>
                        </div>

                        <TextInput
                            id="login-username-field"
                            className="generic-form__field"
                            invalid={invalid_dictionary.invalid_username}
                            invalidText={invalid_dictionary.invalidText_username}
                            labelText="Nombre de usuario"
                            placeholder="Nombre de usuario"
                            value={loginForm.username}
                            name="username"
                            onChange={(e) => checkInputs(e)}
                            autoFocus
                            ref={inputRef}
                        />
                        <TextInput
                            id="login-password-field"
                            className="generic-form__field"
                            invalid={invalid_dictionary.invalid_password}
                            invalidText={invalid_dictionary.invalidText_password}
                            labelText="Contraseña"
                            placeholder="******"
                            type="password"
                            name="password"
                            value={loginForm.password}
                            onChange={(e) => checkInputs(e)}
                            onKeyDown={(e) => doLoginKey(e, doLogin)}
                        />
                        {!authLoading &&
                            <Button
                                className="login-form-elm"
                                kind="primary"
                                renderIcon={ArrowRight}
                                onClick={doLogin}>
                                Acceder
                            </Button>
                        }
                        {authLoading &&
                            <InlineLoading
                                status='active'
                                iconDescription="Active loading indicator"
                                description="Accediendo..."
                            />
                        }
                        {userError && <p className="error">{checkError(userError)}</p>}
                    </div>
                </div>
            </div>
        </div>
    )


    async function doLogin() {
        validate();
        if (!loginForm.username || !loginForm.password) return;

        try {
            await dispatch(tokenRequestThunk(loginForm)).unwrap();
            navigate('/dashboard');
        } catch (err) {
            const httpCode = err?.http_status_code ?? 0;
            const newState = getErrorState(httpCode);

            if (!String(httpCode).startsWith('4')) {
                dispatch(
                    pushNotification(
                        new NotificationModel(
                            'Error en el login',
                            `HTTP error: ${httpCode || 'desconocido'}, contacte con el administrador. soporte@espossible.com`,
                            'error'
                        ).toJson()
                    )
                );
            }

            setinvalidDictionary((prev) => ({ ...prev, ...newState }));
            inputRef.current?.focus();
        }
    }

    function validate() {
        setinvalidDictionary(validateLogin(loginForm, invalid_dictionary));
    }

    function checkInputs(e) {
        const { formData, validationState } = handleLoginInputs(e, loginForm, invalid_dictionary);
        setData(formData);
        setinvalidDictionary(validationState);
    }
}

export default Index
